import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet('competition-team-detail');

export function useCompetitionTeamDetailQuery(competitionId: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.competitionsDetailTeamRetrieve(competitionId);
      return data;
    },
    queryKey: keys.detail(competitionId),
  });
}
